/*
  AquaNatura: Mega-Menü-Verhalten (Desktop-Inline-Menü im Header).

  - Hover auf einen Top-Level-Punkt öffnet sein Untermenü und schliesst die anderen (wechselt).
  - Klick auf den Top-Level öffnet/wechselt ebenfalls; ein bereits offenes Menü wird durch
    Klick NICHT geschlossen.
  - Das Untermenü bleibt offen, wenn die Maus es verlässt (kein Schliessen bei mouseleave) –
    es schliesst erst bei einem Klick ausserhalb des Menüs, bei Escape oder beim Navigieren
    über einen echten Link.
  - Nicht verlinkte Gruppen-Überschriften (href="#") führen keinen Sprung aus.

  Additiv zu Dawns details-disclosure.js: der Offen-Zustand bleibt <details open>, sodass
  Dawns toggle-Logik (Header-preventHide, Animationen) unverändert weiterläuft.
*/
(function () {
  const SEL = 'header-menu';

  function allMenus() {
    return Array.from(document.querySelectorAll(SEL));
  }
  function detailsOf(hm) {
    return hm.querySelector('details.mega-menu');
  }
  function setOpen(d, open) {
    if (!d || d.open === open) return;
    d.open = open;
    const summary = d.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', String(open));
  }
  function closeAll(except) {
    allMenus().forEach((hm) => {
      const d = detailsOf(hm);
      if (d && d.open && d !== except) setOpen(d, false);
    });
  }
  function openOnly(d) {
    setOpen(d, true);
    closeAll(d);
  }

  // Hover-Intent: Das Untermenü öffnet erst nach einer kurzen Verzögerung, damit
  // schnelles Drüberfahren nicht versehentlich Menüs aufklappt. Klick öffnet sofort.
  const HOVER_DELAY = 150;
  let hoverTimer = null;
  function scheduleOpen(d) {
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => openOnly(d), HOVER_DELAY);
  }
  function cancelScheduledOpen() {
    clearTimeout(hoverTimer);
  }

  function bind(hm) {
    const d = detailsOf(hm);
    if (!d || hm.dataset.aqMega) return;
    hm.dataset.aqMega = '1';
    const summary = d.querySelector('summary');

    // Hover öffnet das Untermenü verzögert (Hover-Intent) und wechselt von einem offenen weg.
    if (summary) {
      summary.addEventListener('mouseenter', () => scheduleOpen(d));
      // Verlässt die Maus den Top-Level wieder, bevor die Verzögerung um ist: nicht öffnen.
      summary.addEventListener('mouseleave', cancelScheduledOpen);

      // Klick öffnet/wechselt sofort (ohne Verzögerung); ein bereits offenes Menü bleibt offen.
      summary.addEventListener('click', (e) => {
        cancelScheduledOpen();
        if (d.open) {
          e.preventDefault(); // bleibt offen statt nativem Toggle-Schliessen
        } else {
          // natives Toggle öffnet d; danach die anderen schliessen
          requestAnimationFrame(() => closeAll(d));
        }
      });
    }

    // Nicht verlinkte Überschriften (href="#") sollen nicht zum Seitenanfang springen.
    d.querySelectorAll('.mega-menu__link[href="#"]').forEach((a) => {
      a.addEventListener('click', (e) => e.preventDefault());
    });
  }

  function boot() {
    allMenus().forEach(bind);
  }

  // Klick ausserhalb eines Menüs schliesst alle offenen Untermenüs.
  document.addEventListener('click', (e) => {
    if (!e.target.closest(SEL)) closeAll();
  });
  // Escape schliesst ebenfalls.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
